import { FC } from "react";
import { FaWallet } from "react-icons/fa";
import { ArrowComponent } from "./Arrow";

interface PropsModal {
  setModalOpen: (value: boolean) => void;
}

export const ModalCashBack: FC<PropsModal> = ({ setModalOpen }) => {
  return (
    <div className="min-h-screen w-full fixed left-0 top-0 flex justify-center items-center bg-black px-6 bg-opacity-90 z-50 transition-all duration-500 ease-in-out">
      <div className="container max-w-2xl h-full flex flex-col items-center bg-white rounded-2xl px-2 py-6 shadow-2xl relative">
        <button
          className="absolute top-1 right-3 text-3xl cursor-pointer"
          onClick={() => setModalOpen(false)}
        >
          &times;
        </button>
        <header className="w-full mb-4">
          <div className="text-2xl font-bold text-center gap-0 md:gap-1 flex justify-center flex-col md:flex-row w-full text-[#88BD3D]">
            <span>
              Temos uma ótima
            </span>
            <span>novidade!!</span>
          </div>
        </header>
        <main className="w-full">
          <section className="w-full">
            <p className="text-center text-md text-neutral-700">
              Estamos em constante busca de melhorias e novas funcionalidades
              para nossa plataforma. Como forma de facilitar o uso da ViroTrip,
              fizemos uma alteração no formato do seu saldo:{" "}
              <strong>
                ele ganhou um novo nome,{" "}
                <span className="text-[#88BD3D] font-bold">ViroCash</span>,
                sendo que cada 1 Diária foi convertida para 1.000 ViroCash.
              </strong>
            </p>
            <div className="flex justify-center gap-2 items-center">
              <FaWallet color="blue" className="w-4 h-4 md:w-6 md:h-6" />{" "}
              <span className="md:text-lg text-sm font-semibold text-blue">3 Diárias</span>
              <div className="flex items-center flex-col mt-7">
                <ArrowComponent className="w-24 md:w-52" />
                <p className="md:text-2xl text-xl font-bold text-center text-[#88BD3D]">
                  X 1.000
                </p>
              </div>
              <FaWallet color="blue" className="w-4 h-4 md:w-6 md:h-6" />{" "}
              <span className="md:text-lg text-sm font-semibold text-blue md:-mr-10 -mr-2">
                3000 ViroCash
              </span>
            </div>
            <div>
              <p className="text-center text-sm text-neutral-700 mt-4">
                Essa mudança, além de possibilitar um uso mais eficiente de seu
                saldo, traz junto o programa de CashBack da Virotrip!!
              </p>
              <p className="text-center text-md text-neutral-700 mt-4">
                <strong>
                  Agora, ao fazer reservas você pode ganhar até{" "}
                  <span className="text-[#88BD3D]">150 ViroCash</span> de volta!
                </strong>
              </p>
            </div>
            <div className="flex justify-center items-center">
              <a target="_blank" href="https://www.virotrip.com.br/virocash" className="text-center text-md text-blue underline mt-4 font-semibold" rel="noreferrer">
                Saiba Mais!
              </a>
            </div>
            <section className="mt-4 mx-auto flex justify-center gap-4">
              <button
                type="button"
                className="text-center bg-[--blue] hover:text-white text-neutral-100 py-2 px-8 rounded-2xl"
                onClick={() => setModalOpen(false)}
              >
                OK
              </button>
            </section>
          </section>
        </main>
      </div>
    </div>
  );
};
